import { calculateAge, getInitial } from "../helpers/helper";

const setProfile = (profile) => {
  return {
    dateOfBirth: profile.dateOfBirth || "",
    age: calculateAge(profile.dateOfBirth),
    height: profile.height || "",
    isMale: profile.isMale,
    weight: profile.weight || "",
  };
};
export class Patient {
  _id;
  name;
  initial;
  profile;

  constructor(_id, name, profile) {
    this._id = _id;
    this.name = name;
    this.profile = setProfile(profile);
    this.initial = getInitial(name);
  }
}
